import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {DataListDetail, DataListManagementItem} from "@/models";

export class DataListService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllDataLists(query: {
        name?: string,
        page?: number,
        size?: number
    } = {}, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<DataListManagementItem[]>('/api/DataList', query, cancelToken);
    }

    public SelectDataListDetail(id: number, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<DataListDetail>('/api/DataList/' + id, {}, cancelToken);
    }

    public InsertDataList(value: {
        Name?: string,
        Description?: string,
        CategorySpot?: number,
    }, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<number>('/api/DataList', value, cancelToken);
    }

    public UpdateDataList(id: number, value: DataListDetail, cancelToken?: AbortSignal) {
        return this.baseApiFactory.put('/api/DataList/' + id, value, cancelToken);
    }

    public DeleteDataList(id: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.delete<boolean>('/api/DataList/' + id, {}, cancelToken);
    }
}

lazyRegister.service('DataListService', DataListService);